import React, { useEffect, useState } from "react";
import { RefreshCw, X } from "lucide-react";

export const UpdateBanner = () => {
  const [reg, setReg] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    const on = (e) => setReg(e.detail);
    window.addEventListener("sw-update", on);
    return () => window.removeEventListener("sw-update", on);
  }, []);
  if (!reg) return null;

  const update = () => {
    setBusy(true);
    window.__superaUpdating = true;
    if (reg.waiting) reg.waiting.postMessage({ type: "SKIP_WAITING" });
    else window.location.reload();
    setTimeout(() => window.location.reload(), 4000);
  };

  return (
    <div className="fixed z-[100] left-1/2 -translate-x-1/2 bottom-5 w-[calc(100%-2rem)] max-w-md animate-in fade-in slide-in-from-bottom-4" data-testid="update-banner">
      <div className="flex items-center gap-3 rounded-2xl bg-[#0A1C30] text-white shadow-2xl ring-1 ring-[var(--gold)]/40 pl-4 pr-2 py-2.5">
        <button data-testid="update-banner-btn" onClick={update} disabled={busy} className="flex-1 flex items-center gap-3 text-left">
          <span className="w-9 h-9 rounded-xl bg-[var(--gold)] text-[#0A1C30] grid place-items-center shrink-0">
            <RefreshCw className={`w-4 h-4 ${busy ? "animate-spin" : ""}`} />
          </span>
          <span>
            <span className="block text-sm font-extrabold">Nueva versión disponible</span>
            <span className="block text-xs text-white/70">{busy ? "Actualizando…" : "Toca para actualizar"}</span>
          </span>
        </button>
        <button data-testid="update-banner-close" onClick={() => setReg(null)} aria-label="Cerrar" className="p-2 rounded-lg text-white/60 hover:text-white hover:bg-white/10"><X className="w-4 h-4" /></button>
      </div>
    </div>
  );
};
